module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col overflow-y-auto pb-2 rounded",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.handleClose()
      }
    }
  }, [_c('div', {
    class: ['px-2 mb-2.5 w-full', {
      'mt-9': _vm.isFullscreen
    }]
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5 bg-gray-100 rounded-full py-1.5 px-4 flex-1 min-w-0 overflow-hidden"
  }, [_c('button', {
    staticClass: "flex-shrink-0 hover:text-primary",
    on: {
      "click": function($event) {
        return _vm.previousUser(_vm.userSelected)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-left text-xs"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2 font-manrope flex-1 min-w-0 overflow-hidden whitespace-nowrap"
  }, [_c('img', {
    staticClass: "flex-shrink-0 rounded-full w-6 h-6",
    attrs: {
      "src": _vm.userSelected.user.avatar_url
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-semibold text-gray-800 truncate"
  }, [_vm._v("\n            " + _vm._s(_vm.userSelected.user.name) + "\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "flex-shrink-0 hover:text-primary",
    on: {
      "click": function($event) {
        return _vm.nextUser(_vm.userSelected)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-right text-xs"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-1 ml-4 flex-shrink-0"
  }, [_c('button', {
    staticClass: "text-gray-400 w-7 h-7 rounded-full bg-gray-100 flex-shrink-0"
  }, [_c('i', {
    staticClass: "fa-solid fa-bullhorn text-xs"
  }), _vm._v("\n          " + _vm._s(_vm.totalTurns) + "\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.left",
      value: ('Send Nudge'),
      expression: "'Send Nudge'",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "text-gray-600 w-7 h-7 rounded-full hover:bg-gray-100 flex-shrink-0",
    on: {
      "click": function($event) {
        return _vm.$emit('openSendNudge', true, _vm.userSelected)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-hand-pointer"
  })]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-800 w-7 h-7 rounded-full hover:bg-gray-100 flex items-center justify-center flex-shrink-0",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-close text-sm"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2",
    class: _vm.isFullscreen ? 'max-height-list-fullscreen' : 'max-height-list'
  }, [_c('div', {
    staticClass: "px-2"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded flex justify-between px-3 py-1.5 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.toggleTabs('studentNotes')
      }
    }
  }, [_c('h5', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("Student Notes")]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-800"
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-down",
    class: _vm.isOpenStudentNotes === true ? 'fa-angle-down' : 'fa-angle-up'
  })])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpenStudentNotes === true),
      expression: "isOpenStudentNotes === true"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userSelected.notes.content),
      expression: "userSelected.notes.content"
    }],
    ref: "textareaNotes",
    staticClass: "w-full border-solid border border-gray-200 mt-2 px-2.5 py-2 rounded outline-none",
    attrs: {
      "placeholder": _vm.userSelected.notes.content === '' ? 'There are no notes yet' : '',
      "rows": _vm.notesRows,
      "disabled": ""
    },
    domProps: {
      "value": (_vm.userSelected.notes.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userSelected.notes, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "px-2"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded mb-2 flex justify-between px-3 py-1.5 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.toggleTabs('teacherNotes')
      }
    }
  }, [_c('h5', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("Teacher Notes")]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-800"
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-down",
    class: _vm.isTeacherNotesOpen === true ? 'fa-angle-down' : 'fa-angle-up'
  })])]), _vm._v(" "), (_vm.isTeacherNotesOpen === true) ? _c('TeacherNotes', {
    attrs: {
      "participation": _vm.getStudentSummaryLD
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "px-2"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded flex justify-between px-3 py-1.5 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.toggleTabs('assessment')
      }
    }
  }, [_c('h5', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("Assessment")]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-800"
  }, [_c('i', {
    staticClass: "fa-solid",
    class: _vm.isOpenAssessment === true ? 'fa-angle-down' : 'fa-angle-up'
  })])]), _vm._v(" "), (_vm.isOpenAssessment === true && _vm.hasTeacherPermissionsInCourse) ? _c('div', [(_vm.participation !== null || _vm.participation !== undefined) ? _c('LiveDiscussionPointsBar', {
    attrs: {
      "showEditAssessment": true,
      "participation": _vm.userSelected
    },
    on: {
      "editAssessment": function($event) {
        return _vm.$emit('editAssessment')
      },
      "saveAssessment": _vm.saveAssessment
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "px-2"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded flex justify-between px-3 py-1.5 cursor-pointer",
    attrs: {
      "id": "open-student-feedback"
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabs('feedback')
      }
    }
  }, [_c('div', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("\n          Feedback\n          "), (_vm.hasTeacherPermissionsInCourse && _vm.hasFeedback) ? _c('span', {
    staticClass: "text-green-500"
  }, [_vm._v("\n            (Sent)\n          ")]) : (_vm.hasTeacherPermissionsInCourse && _vm.draftFeedback) ? _c('span', {
    staticClass: "text-yellow-400"
  }, [_vm._v("\n            (Draft)\n          ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-800"
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-down",
    class: _vm.isOpenFeedback === true ? 'fa-angle-down' : 'fa-angle-up'
  })])]), _vm._v(" "), (_vm.isOpenFeedback === true) ? _c('div', [_c('div', {
    staticClass: "w-full rounded outline-none focus-within:border-primary border border-solid border-gray-200"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSuggestion),
      expression: "selectedSuggestion"
    }],
    ref: "feedback-textarea",
    staticClass: "p-2.5 w-full h-full rounded outline-none",
    attrs: {
      "rows": "6",
      "disabled": !_vm.hasTeacherPermissionsInCourse || !_vm.edit_feedback,
      "placeholder": 'Send private feedback to ' + _vm.userSelected.user.name
    },
    domProps: {
      "value": (_vm.selectedSuggestion)
    },
    on: {
      "blur": _vm.saveDraftFeedback,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedSuggestion = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.edit_feedback) ? _c('div', {
    staticClass: "flex justify-between items-center p-2 border-t"
  }, [_c('button', {
    staticClass: "sample flex items-center p-1 rounded hover:bg-gray-100 space-x-1.5 text-gray-600",
    on: {
      "click": _vm.showTemplateModal
    }
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/templates.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Templates")])]), _vm._v(" "), _c('div', [(_vm.saving) ? _c('span', {
    staticClass: "pulsate text-xs px-1"
  }, [_vm._v("\n                Saving...\n              ")]) : _vm._e(), _vm._v(" "), (_vm.saved) ? _c('span', {
    staticClass: "text-xs px-1"
  }, [_vm._v("Saved")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.edit_feedback) ? _c('button', {
    staticClass: "sample bg-primary rounded py-2 px-4 my-3 text-white font-semibold w-full",
    on: {
      "click": function($event) {
        return _vm.sendFeedbackToStudent()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.hasFeedback ? 'Update Feedback' : 'Send Feedback') + "\n        ")]) : (_vm.hasTeacherPermissionsInCourse && !_vm.edit_feedback) ? _c('button', {
    staticClass: "sample py-2 px-4 my-3 w-full bg-gray-400 hover:bg-gray-500 rounded text-white font-semibold",
    on: {
      "click": function($event) {
        _vm.edit_feedback = true
      }
    }
  }, [_vm._v("\n          Edit Feedback\n        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "px-2"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded flex justify-between px-3 py-1.5 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.toggleTabs('tapInDetails')
      }
    }
  }, [_c('h5', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("Participation Details")]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-800"
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-down",
    class: _vm.isOpenTapInDetails === true ? 'fa-angle-down' : 'fa-angle-up'
  })])]), _vm._v(" "), (_vm.isOpenTapInDetails) ? _c('div', {
    staticClass: "my-2.5"
  }, [_c('TapInStudent', {
    attrs: {
      "tapInStudentDetails": _vm.getStudentSummaryLD.times_spoken,
      "isStudentDetails": true
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "px-2"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded flex justify-between px-3 py-1.5 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.toggleTabs('nudges')
      }
    }
  }, [_c('h5', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("Nudges")]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-800"
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-down",
    class: _vm.isOpenNudges === true ? 'fa-angle-down' : 'fa-angle-up'
  })])]), _vm._v(" "), (_vm.isOpenNudges) ? _c('div', {
    staticClass: "m-3 h-48 overflow-y-auto sample"
  }, [(!_vm.getStudentSummaryLD.nudges.length) ? _c('div', [_vm._v("\n          No nudges during this RoundTable\n        ")]) : _c('div', {
    staticClass: "mt-3"
  }, [_c('StudentNudges', {
    attrs: {
      "nudges": _vm.getStudentSummaryLD.nudges
    }
  })], 1)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-04151ff0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/Participants/Participant.vue
// module id = 1815
// module chunks = 61